<template>
    <KHero
        v-editable="blok"
        as="header"
        class="main-header"
        :title="blok.title"
        :text="blok.text"
    >
        <template #media>
            <NuxtImg
                v-if="blok.image?.filename"
                width="960"
                height="340"
                fit="cover"
                format="auto"
                sizes="xs:100vw sm:100vw md:960px"
                :src="blok.image.filename"
                :alt="blok.image.alt"
                :loading="priority ? 'eager' : 'lazy'"
                :fetchpriority="priority ? 'high' : undefined"
                :preload="priority ? { fetchPriority: 'high' } : false"
            />
        </template>
    </KHero>
</template>

<script setup>
import { KHero } from '@vemedia/karibu'

defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },

    // The parent decides whether THIS header is the page's LCP image and
    // forwards `priority` through StoryblokComponent's attr fallthrough. See
    // hero.vue for why that's explicit parent designation rather than a
    // derived first-blok check, and why eager/fetchpriority/preload are
    // gated together.
    priority: {
        type: Boolean,
        default: false,
    },
})
</script>

<style lang="scss">
@use '@vemedia/karibu/styles/responsive' as *;

.main-header {
    --hero-content-gap: var(--space-5);
    --hero-padding-block: var(--space-11);
    --hero-title-measure: var(--container-1);
    --hero-text-measure: var(--container-1);

    @include tablet {
        border-radius: var(--radius-5);
    }

    @include desktop {
        --hero-padding-block: 10rem;
    }
}
</style>
